import {API} from "@/Composables/api";

const getGroups = async (params = {}) => {
    return API.get(route("groups.index"), params);
};

const getGroup = async (group, params = {}) => {
    return API.get(route("groups.show", group), params);
};

const getUserGroups = async (params = {}) => {
    return API.get(route("groups.index.owned"), params);
};

const getAdminGroups = async (params = {}) => {
    return API.get(route("groups.index.admin"), params);
};

const getMemberGroups = async (params = {}) => {
    return API.get(route("groups.index.member"), params);
};

const storeGroup = async (group, params = {}) => {
    return API.post(route("groups.store"), params, group);
};

const updateGroup = async (group, params = {}) => {
    return API.put(route("groups.update", group), params, group);
};

const cloneGroup = async (group: string, data: object, params = {}) => {
    return API.post(route("groups.clone", group), params, data);
};

const getGroupQuestionnaires = async (group, params) => {
    return API.get(route("groups.questionnaires.index", group), params);
};

const getGroupQuestionnaire = async (group, questionnaire, params) => {
    return API.get(route("groups.questionnaires.show", [group, questionnaire]), params);
};

const transferGroupOwnership = async (group: string, user: string, params = {}) => {
    return API.put(route("groups.transfer-ownership", [group, user]), params);
};

const deleteIcon = async (group: string, icon: string) => {
    return API.delete(
        route("media.destroy", {
            modelType: "group",
            modelId: group,
            collectionName: "icon",
            mediaId: icon,
        }),
    );
};

const deleteGroup = async (group: string, params = {}) => {
    return API.delete(route("groups.destroy", group), params);
};

const togglePostingRule = async (group: string, allowMemberPosts: boolean) => {
    return API.put(route("groups.toggle-posting-rule", group), {}, {allow_member_posts: allowMemberPosts});
};

const toggleLinearFlow = async (group: string, linearFlow: boolean) => {
    return API.put(route("groups.toggle-linear-flow", group), {}, {linear_flow: linearFlow});
};

const exportGroupData = async (group: string, params = {}) => {
    return API.get(route("groups.export", group), params);
};

export {
    getGroups,
    getUserGroups,
    getAdminGroups,
    getMemberGroups,
    getGroup,
    storeGroup,
    updateGroup,
    cloneGroup,
    transferGroupOwnership,
    getGroupQuestionnaires,
    getGroupQuestionnaire,
    deleteIcon,
    deleteGroup,
    togglePostingRule,
    toggleLinearFlow,
    exportGroupData,
};
